import { Box, Image, Heading, Flex } from '@chakra-ui/react';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';

import { easyTeamScheduling, trackTimeAndMileage, trackTeamMembers } from 'assets/images';
import 'assets/scss/vendors/react-slick.scss';

const SlickSlider: React.FC<{}> = () => {
  const { t } = useTranslation(['auth']);

  const settings = {
    dots: true,
    infinite: true,
    arrows: false,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    lazyload: 'onDemand',
    slidesToScroll: 1,
  };

  const sliders = [
    {
      heading: t('auth:trackTimeAndMileageAccurately'),
      image: trackTimeAndMileage,
    },
    {
      heading: t('auth:stopWonderingWhereEveryoneIs'),
      image: trackTeamMembers,
    },
    {
      heading: t('auth:easyTeamScheduling'),
      image: easyTeamScheduling,
    },
  ];

  return (
    <Box height="100%" bg="primary.500">
      <Slider {...settings}>
        {sliders.map(({ heading, image }, index) => (
          <Box py="20" key={index} height="100vh">
            <Heading as="h2" size="xl" color="white" px={{ base: '10', xl: '20' }} mb={{ base: '1', xl: '5' }}>
              {heading}
            </Heading>
            <Flex justifyContent="center" alignItems="center" p="6">
              <Image alt={t('auth:loginImage')} objectFit={'cover'} src={image} />
            </Flex>
          </Box>
        ))}
      </Slider>
    </Box>
  );
};

export default memo(SlickSlider);
